import { Container, Row, Col } from "react-bootstrap";
import { InternationalHospitalCard } from "../../Components/ui/InternationalHospitalCard/InternationalHospitalCard";
import { internationalHospitals } from "../../data/internationalHospitals";
import heroBg from "../../assets/images/aboutus-bg.png";
import "./internationalhospitalcollaborations.css";

export const Internationalhospitalcollaborations = () => {
  return (
    <div className="ihc-page">
      <section
        className="store-page__hero"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <div className="store-page__hero-overlay">
          <Container>
            <p className="store-page__hero-label">International Collaborations</p>
            <h1 className="store-page__hero-title">
              Learn from leading doctors and specialists through focused, digestible video content.
            </h1>
          </Container>
        </div>
      </section>

      {/* ── Partner Hospitals Grid ── */}
      <section className="ihc-partners">
        <Container>
          <h2 className="ihc-partners__heading">
            Partner Hospitals Joined Bizaario
          </h2>
          <p className="ihc-partners__sub">
            Learn from leading doctors and specialists through focused,
            digestible video content.
          </p>

          <Row className="g-4">
            {internationalHospitals.map((hospital) => (
              <Col key={hospital.id} xs={12} sm={6} lg={4}>
                <InternationalHospitalCard
                  logo={hospital.logo}
                  name={hospital.name}
                  onViewProfile={() => {}}
                />
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </div>
  );
};
